<template>
    <v-select
            :label="label"
            :items="items"
            v-model="modelValue"
            item-value="value"
            item-text="label"
            :placeholder="field.ayuda"
            :class="field.extra.attributes"
            :readonly="readonly"
            :rules="rules"
            outlined
            return-object
            @change="onSelectChange"
    />

</template>

<script>
    import procedureFormValidator from "../../../form/procedure.form.validator";
    import {Procedures as ProceduresApi} from "../../../api";

    export default {
        name: "Select",
        props: ['field', 'readonly', 'label', 'stageId', 'formValues', 'dynamicTable', 'apiAjax'],
        data(){
            return {
                rules: [procedureFormValidator.input.required(this.field.validacion.required, this.readonly)],
                items: [],
                data: {data1: ''},

                formValue: null
            }
        },  

        created() {
            this.items = this.field.datos
            this.loadUrlData()

            this.addWatcherToDepends()
            this.verifyDefaultValue()
        },

        computed: {
            modelValue: {
                get() {
                    if (this.dynamicTable){
                        if (this.formValues[this.field.nombre] === null){
                            this.resetFieldValueForDynamicTable()
                            return this.formValues[this.field.nombre].value
                        }
                    }

                    return this.formValues[this.field.nombre]
                },

                set(newVal){
                    if (this.dynamicTable){
                        this.formValues[this.field.nombre].value = newVal
                    }else {
                        this.formValues[this.field.nombre] = newVal
                    }
                }
            }
        },

        methods: {
            async loadUrlData(){
                if (this.field.extra && this.field.extra.catalog_type == 'url'){
                    let params = ''

                    if (this.field.extra.populated_by && Array.isArray(this.field.extra.populated_by)){
                        let populatedBy = this.field.extra.populated_by
                        for (let i=0 ; i<populatedBy.length; i++){
                            if (this.dynamicTable){
                                params += `${populatedBy[i]}=${this.formValues[populatedBy[i]].value}&`
                            }else {
                                params += `${populatedBy[i]}=${this.formValues[populatedBy[i]]}&`
                            }
                        }
                    }

                    this.items = await ProceduresApi.getFormSelectValues(this.stageId, this.field.id, params)
                }
            },

            addWatcherToDepends(){
                if (this.field.extra.populated_by && Array.isArray(this.field.extra.populated_by)){
                    let populatedBy = this.field.extra.populated_by

                    for (let i=0 ; i<populatedBy.length; i++){
                        this.$watch(
                            () => {
                                return this.formValues[populatedBy[i]]
                            },
                            () => {
                                this.someDependChanged()
                            }
                        )
                    }
                }
            },

            someDependChanged(){
                this.items = []
                this.loadUrlData()
            },

            onSelectChange(item){
                if (this.dynamicTable){
                    this.formValues[this.field.nombre] = {value: item.value, label: item.label}
                }else {
                    this.formValues[this.field.nombre] = item.value
                }

                this.tryExecuteApiAjaxEvent('change')
            },

            tryExecuteApiAjaxEvent(eventType){
                if (this.apiAjax != null){
                    if (eventType === this.apiAjax['event']){
                        this.$root.$emit(`fire_${this.apiAjax.originFieldId}`)
                    }
                }
            },

            resetFieldValueForDynamicTable(){
                this.formValues[this.field.nombre] = {value: null, label: null}
            },

            verifyDefaultValue(){
                if (!this.dynamicTable){
                    let value = this.formValues[this.field.nombre]

                    if (Array.isArray(value) && value.length > 0){
                        let newVal = value[0]

                        if (typeof newVal == 'object'){
                            newVal = newVal.value
                        }

                        this.formValues[this.field.nombre] = newVal
                    }
                }

            }
        },
        watch: {
            modelValue () {
            }
        }

    }
</script>

<style scoped>

</style>